import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavbarLandingsPage.css';
import logo from '../assets/balklanding.png';

const NavbarLandingsPage = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    // Handle scrolling effect
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close menu when clicking links
    const handleLinkClick = () => {
        setIsOpen(false);
    };

    // Disable body scroll when menu is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    return (
        <nav
            className={`navbar navbar-expand-lg navbar-dark fixed-top ${scrolled ? 'scrolled' : ''}`}
            style={{
                backgroundColor: scrolled ? 'rgba(19, 21, 23, 0.95)' : '#131517',
                height: '70px',
                transition: 'all 0.3s ease',
                boxShadow: scrolled ? '0 4px 20px rgba(0, 0, 0, 0.3)' : 'none'
            }}
        >
            <div className="container-fluid navbarcontainer">
                <Link className="navbar-brand" to="/home" aria-label="Homepage">
                    <img
                        src={logo}
                        alt="HorecaMasters Logo"
                        className="navbar-logo"
                    />
                </Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-controls="navbarNav"
                    aria-expanded={isOpen}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div
                    className={`navbar-collapse ${isOpen ? 'show' : ''}`}
                    id="navbarNav"
                    style={{
                        display: isOpen ? 'block' : 'none',
                        animation: isOpen ? 'fadeIn 0.3s ease-in-out' : 'none'
                    }}
                >
                    <ul className="navbar-nav navbar-links-container">
                        <li className="nav-item" onClick={handleLinkClick}>
                            <a className="nav-link-a" href="/home#home">Home</a>
                        </li>
                        <li className="nav-item-f" onClick={handleLinkClick}>
                            <a className="nav-link-f" href="/home#features">Features</a>
                        </li>
                        <li className="nav-item-s" onClick={handleLinkClick}>
                            <a className="nav-link-s" href="/home#pricing">Subscriptions</a>
                        </li>
                        <li className="mobile-login" onClick={handleLinkClick}>
                            <Link className="nav-link-login" to="/login">
                                Login
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="navbar-login-container desktop-login">
                    <li className="nav-item">
                        <Link
                            className="nav-link-login"
                            to="/login"
                        >
                            Login
                        </Link>
                    </li>
                </div>
            </div>
        </nav>
    );
};

export default NavbarLandingsPage;
